import { NavigationTree } from '@wpp-open/core'

import { facadeApi } from 'api'

export const fetchNavigationTreeAncestorsApi = ({ tenantId, parentId }: { tenantId: string; parentId?: string }) =>
  facadeApi.get<NavigationTree>(`/v3/tenants/${tenantId}/navigation-tree/node/${parentId}/ancestors`)
